import { Box, Grid, Pagination } from '@mui/material';
import { Stack } from '@mui/system';
import { ColDef } from 'ag-grid-community';
import { AgGridReact, AgGridReactProps } from 'ag-grid-react';
import React, { Dispatch, SetStateAction, useCallback, useState } from 'react';

const GridButton = ({ left, right }: any) => {
  return (
    <Grid
      alignItems="center"
      container
      sx={{
        mb: '10px',
        mt: '40px',
        // , border: 1, borderColor: 'red'
      }}
    >
      {left ? (
        <Grid
          item
          sx={{ display: 'flex', alignItems: 'center' }}
          xs={6}
        >
          {left}
        </Grid>
      ) : null}
      {right ? (
        <Grid
          item
          sx={{ display: 'flex', justifyContent: 'flex-end' }}
          xs={6}
        >
          {right}
        </Grid>
      ) : null}
    </Grid>
  );
};

type Props = {
  context?: any;
  leftButton?: React.ReactNode;
  rightButton?: React.ReactNode;
  children?: React.ReactNode;
  total?: number;
  isPaging?: boolean;
  setPage?: Dispatch<SetStateAction<number>>;
  page?: number;
  paginationPageSize?: number;
  isDefaultPaging?: boolean;
  style?: {
    width?: string;
    height?: string;
  };
  isLoading?: boolean;
  noRowsToShowText?: string;
} & TGridContent &
  AgGridReactProps;

const GridArea = ({ leftButton = false, rightButton = false, ...rest }: Props) => {
  return (
    <Box>
      {leftButton ||
        (rightButton && (
          <GridButton
            left={leftButton}
            right={rightButton}
          />
        ))}
      <GridContent {...rest} />
    </Box>
  );
};

type TGridContent = {
  defaultColDef?: ColDef;
  style?: {
    width?: string;
    height?: string;
  };
  editType?: 'fullRow';
  rowData: Array<any>;
  columnDefs;
  detailRowAutoHeight?: boolean;
  domLayout: 'normal' | 'autoHeight' | 'print';
  animateRows?: boolean;
  headerHeight?: number;
  onRowClicked?: any;
  gridRef;
  isPaging?: boolean;
  rowHeight?: number;
  className?: string;
  onGridReady?: any;
  onGridSizeChanged?: any;
  onRowDataUpdated?: any;
  onColumnGroupOpened?: any;
  onFirstDataRendered?: any;
  total?: number;
  page?: number;
  onSelectionChanged?: any;
  setPage?: Dispatch<SetStateAction<number>>;
  paginationPageSize?: number;
  isDefaultPaging?: boolean;
  noRowsToShowText?: string;
  isLoading?: boolean;
} & AgGridReactProps;
const GridContent = ({
  defaultColDef,
  style = {
    width: '100%',
    // height: 600,
  },
  rowData = [],
  columnDefs,
  domLayout = 'normal',
  gridRef,
  onGridReady,
  total,
  isPaging = true,
  setPage,
  page,
  isLoading,
  noRowsToShowText = '조회 결과가 없습니다.',
  ...rest
}: TGridContent) => {
  const onReady = useCallback((params) => {
    // console.log('grid ready!!!');
    onGridReady && onGridReady(params);
  }, []);

  return (
    <>
      <div>
        <div className="ag-theme-alpine">
          <div style={style}>
            <AgGridReact
              {...rest}
              ref={gridRef}
              defaultColDef={defaultColDef}
              onGridReady={onReady}
              // onGridSizeChanged={onReady}
              columnDefs={columnDefs}
              rowData={rowData}
              domLayout={domLayout}
              // animateRows={animateRows}
              // suppressHorizontalScroll={false}
              columnHoverHighlight={false}
              // detailRowAutoHeight={detailRowAutoHeight}
              // suppressPaginationPanel
              // enableCellChangeFlash // 변경될때 깜빡임
              // suppressScrollOnNewData
              localeText={{ noRowsToShow: noRowsToShowText }}
              // onDisplayedColumnsChanged={onDisplayedColumnsChanged}
              // onCellClicked={(event) =>
              //   console.log("Cell was clicked", event.column.colId)
              // }
              enableCellTextSelection
            />
          </div>
        </div>
      </div>
      {isPaging ? (
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          sx={{ mt: 5 }}
        >
          <Stack>
            <Pagination
              count={total?total:0}
              showFirstButton
              showLastButton
              color="primary"
              page={page}
              onChange={(event: React.ChangeEvent<unknown>, value: number) => {
                setPage(value);
              }}
            />
          </Stack>
        </Box>
      ) : null}
    </>
  );
};

export { GridArea, GridButton };
